import ModalFormOpener from "../../../components/actions/ModalFormOpener";
import {
  createReviews,
  getReviews,
  updateReviews,
} from "../../../services/api/queries/course";
import reviewFields from "../formFields/reviewFields";

const reviewListViewMeta = () => {
  return {
    columns: [
      {
        Header: "Sort",
        accessor: "sort",
      },
      {
        Header: "Reviewer Name",
        accessor: "reviewer_name",
      },
      {
        Header: "Reviewer Name (Bangla)",
        accessor: "reviewer_name_bn",
      },
      {
        Header: "Rating",
        accessor: "rating",
      },
      {
        Header: "Course",
        accessor: "course",
        Cell: ({ value }) => value?.name || "",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Show In B2C",
        accessor: "show_in_landing",
        Cell: ({ value }) => (value ? "✓" : "X"),
      },
      {
        Header: "",
        accessor: "actions",
        options: [
          (defaultValues) => (
            <ModalFormOpener
              key="edit"
              submitService={updateReviews}
              fields={reviewFields}
              heading={"Edit a Review!"}
              openerText="Edit"
              parentId="modal_span"
              defaultValues={{
                ...defaultValues,
                reviewer_image: [defaultValues.reviewer_image],
                course: defaultValues.course?.id
                  ? defaultValues.course?.id
                  : defaultValues.course,
              }}
              refreshEvent="refresh_table"
              size="xl"
              doNotReset={true}
              successMessage="Review updated!"
              openerClassName="w-100"
            />
          ),
        ],
      },
    ],
    actions: [
      <ModalFormOpener
        key="edit"
        submitService={createReviews}
        fields={reviewFields}
        heading={"Create a Review!"}
        openerText="+ Add Review"
        parentId="modal_span"
        refreshEvent="refresh_table"
        size="xl"
        doNotReset={true}
        successMessage="Review Created!"
        openerClassName="btn btn-primary"
      />,
    ],
    queryService: getReviews,
    modelName: "coursereview",
  };
};

export default reviewListViewMeta;
